import { render, staticRenderFns } from "./RecipeUnitForm.vue?vue&type=template&id=269aefd9&scoped=true"
import script from "./RecipeUnitForm.vue?vue&type=script&lang=js"
export * from "./RecipeUnitForm.vue?vue&type=script&lang=js"
import style0 from "./RecipeUnitForm.vue?vue&type=style&index=0&id=269aefd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269aefd9",
  null
  
)

export default component.exports